<template>
  <router-view />
</template>

<script>
export default {
  name: 'StoreLayout',
}
</script>

<style scoped></style>
